import defer from 'lodash/defer';
import {
  getFavoriteVenues, initObserveStore, observeStore,
} from '@resy/ui-kitchen';

import getConnectedActions from '../../modules/actions/connectedActions';
import { fetchLeaderboards } from '../../../../ui-kitchen/src/reducers/collectionsSlice';
import { getResyLocationsSelectedThunk } from '../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import { getSelectedCoreISODateThunk, getSelectedCoreSeatsThunk, getSelectedCoreTimeThunk } from '../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { ISO_DATE_FORMAT } from '../../../../ui-kitchen/src/constants/resyCore';
import { RESY__DISCOVERY_COLLECTIONS } from '../../../../ui-kitchen/src/constants/optimizelyExperiments';
import { selectIsAuthenticated } from '../../../../ui-kitchen/src/reducers/authTokenSlice';
import { shouldDisplayAd } from '../../../../ui-kitchen/src/components/AmexAds/helpers';
import getLatLng from '../../../../ui-kitchen/src/utils/getLatLngThunk';
import Logger from '../../../../ui-kitchen/src/utils/logger';

angular.module('resyApp')
  .component('resyHome', {
    templateUrl: 'components/home/home.html',
    controller: ResyHomeController,
    controllerAs: 'vm',
  });

function ResyHomeController($scope, $rootScope, $routeParams, $location, $translate, ResyEvents) {
  /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["$rootScope"] }] */
  const vm = this;
  const store = $rootScope.reduxStore;
  const { dispatch, getState } = store;
  const {
    fetchVenuesForBookTonight,
    fetchVenueRecommendations,
    fetchVenuesForCollection,
    resetFavorites,
  } = getConnectedActions(dispatch);

  /**
   * Expected to be in YYYY-MM-DD format.
   * Will come from service as a Date and be immediately converted.
   */

  vm.selectedDate = null;
  vm.selectedPartySize = null;
  vm.selectedLocation = undefined;
  vm.showAllCitiesHeader = false;
  vm.locationCode = $routeParams.location;
  vm.locationSlug = null;
  vm.latLng = null;
  vm.collections = [];
  vm.eventsByLocation = null;
  vm.fetchVenuesForCollection = fetchVenuesForCollection;
  vm.isAuthenticated = selectIsAuthenticated(getState());
  vm.loadNotifyModal = loadNotifyModal;
  vm.containerQuery = $rootScope.matchMedia;
  vm.getBookTonight = getBookTonight;
  vm.getRecommendations = getRecommendations;
  vm.bookTonightVenues = null;
  vm.recommendedVenues = null;
  vm.platinumCollection = null;
  vm.bookTonightVenuesIsLoading = false;
  vm.recommendedVenuesIsLoading = false;
  vm.showAuthModal = showAuthModal;
  vm.isRecommendationsRefreshed = false;
  vm.shouldShowAmexAds = selectShouldShowAmexAds(getState()) ?? false;

  let Collections = {};

  /**
   * Formats holds the information used to display the Book Tonight collection's name with i18n support.
   * The default values are for english, and are updated in the loadDatepicker function if applicable.
   */
  vm.bookTonight = {
    name: null,
    formats: {
      sm: {
        sameDay: '[Book Tonight]',
        nextDay: '[Book Tomorrow]',
        nextWeek: '[Book for] MMM. Do',
        sameElse: '[Book for] MMM. Do',
      },
      md: {
        sameDay: '[Book Tonight]',
        nextDay: '[Book Tomorrow]',
        nextWeek: '[Book for] MMMM Do',
        sameElse: '[Book for] MMMM Do',
      },
    },
  };

  vm.recommendations = {
    name: null,
  };

  vm.$onInit = onInit;

  function onInit() {
    setupReactors();
    loadLocationAndCollections();
    loadDate();
    loadTime();
    loadPartySize();
    shouldShowAuth();
    loadEventsByLocation();
    loadFavorites();
    scrollToSection();
  }

  function scrollToSection() {
    const { section } = $location.search();
    if (section === 'download') {
      setTimeout(() => {
        const el = document.getElementById('download-app');
        if (el) {
          const nav = document.querySelector('resy-nav');
          const navHeight = nav ? nav.offsetHeight : 0;
          window.scrollTo({ top: el.offsetTop - navHeight, behavior: 'smooth' });
        }
      }, 1500);
    }
  }

  function showAuthModal(successCallback) {
    $rootScope.$broadcast('MODAL', 'signin', { successCallback });
  }

  function getPersonalizedKey() {
    return `${vm.locationCode}-${vm.selectedDate}-${vm.selectedTime}-${vm.selectedPartySize}-${vm.isAuthenticated}`;
  }

  function getRecommendations(data) {
    if (vm.isAuthenticated) {
      const payload = {
        ...data,
        location_id: data.location,
        limit: 19,
        isAuth: true,
      };

      const key = getPersonalizedKey();
      if (!Collections?.lists?.all[key]) fetchVenueRecommendations(payload);
    }
  }

  function getBookTonight(data) {
    const payload = {
      ...data,
      isAuth: (vm.isAuthenticated),
    };
    const key = getPersonalizedKey();
    if (!Collections?.lists?.all[key]) fetchVenuesForBookTonight(payload);
  }

  const onFavoriteSliceChange = ({ favorite }) => {
    vm.favoriteVenueIds = favorite.venueIds;
    defer(() => $scope.$apply());
  };

  const unsubscribeFavoriteSlice = observeStore(
    $rootScope.reduxStore,
    ({ favorite }) => ({ favorite }),
    onFavoriteSliceChange
  );

  const onCollectionsSliceChange = ({ collections }) => {
    Collections = collections;
    if (vm.locationCode) {
      const key = getPersonalizedKey();
      vm.bookTonightVenuesIsLoading = collections.venues.book_tonight.isLoading;
      vm.recommendedVenuesIsLoading = collections.venues.recommendations.isLoading;

      if (collections.venues.book_tonight[key]) {
        vm.bookTonightVenues = collections.venues.book_tonight[key];
      }

      if (collections.venues.recommendations[key]) {
        if (!vm.isRecommendationsRefreshed) {
          const randomizedRecommendedVenueList = Array.from(collections.venues.recommendations[key]).sort(() => Math.random() - 0.5);
          vm.recommendedVenues = randomizedRecommendedVenueList.slice(0, 5);
          vm.isRecommendationsRefreshed = true;
        } else {
          vm.recommendedVenues = collections.venues.recommendations[key];
        }
      }
    }

    const key = `${vm.locationCode}-1-${vm.isAuthenticated}`;
    if (collections.lists.all[key]) {
      const { curated, all } = collections?.lists?.all[key];
      vm.collections = { ...curated };
      vm.platinumCollection = all?.find((collection) => collection?.info?.collection_slug === 'amex-platinum-nights');
    }
    defer(() => $scope.$apply());
  };

  const unsubscribeCollectionsSlice = observeStore(
    $rootScope.reduxStore,
    ({ collections }) => ({ collections }),
    onCollectionsSliceChange
  );

  const unsubscribeExperimentsSlice = observeStore(
    $rootScope.reduxStore,
    ({ experiments, ipdata }) => ({
      experiments,
      countryCode: ipdata?.countryCode,
    }),
    () => {
      const state = getState();
      vm.shouldShowAmexAds = selectShouldShowAmexAds(state) ?? false;
      vm.showDiscoveryCollections = !!state?.experiments?.[RESY__DISCOVERY_COLLECTIONS]?.enabled;
      defer(() => $scope.$apply());
    }
  );

  const onResyLocationsSliceChange = (resyLocations) => {
    const { selected } = resyLocations;
    if (selected?.code !== vm.locationCode) {
      vm.locationCode = selected?.code;
      vm.locationSlug = selected?.url_slug;
      vm.locationTier = selected?.content_tier;
      vm.selectedLocation = selected;
      vm.showAllCitiesHeader = !!selected?.all_cities_header;
      loadLatLng();
      loadEventsByLocation();
      if (vm.locationSlug) {
        dispatch(fetchLeaderboards({
          locationSlug: vm.locationSlug,
          limit: 5,
        }));
      }
      loadLocationAndCollections();
      defer(() => $scope.$apply());
    }
  };
  const observeResyLocationsSlice = initObserveStore(store, ({ resyLocations }) => (resyLocations));
  const unsubscribeResyLocationsSlice = observeResyLocationsSlice(onResyLocationsSliceChange);

  const onResyCoreSliceChange = (resyCoreSlice) => {
    const { selectedCoreISODate, selectedCoreSeats, selectedCoreTime } = resyCoreSlice;

    // SELECTED_TIME_UPDATED handling
    if (vm.selectedTime !== selectedCoreTime) {
      vm.selectedTime = selectedCoreTime;
    }

    // SELECTED_DATE_UPDATED handling
    // vm.selectedDate is in ISO Date format
    if (vm.selectedDate !== selectedCoreISODate) {
      vm.selectedDate = selectedCoreISODate;
      const formats = !$rootScope.matchMedia.md ? vm.bookTonight.formats.sm : vm.bookTonight.formats.md;
      vm.bookTonight.name = moment(vm.selectedDate, ISO_DATE_FORMAT).calendar(null, formats);
      loadEventsByLocation();
    }

    // PARTY_SIZE_SELECTED_UPDATED handling
    if (vm.selectedPartySize !== selectedCoreSeats) {
      vm.selectedPartySize = selectedCoreSeats;
    }
    defer(() => $scope.$apply());
  };
  const observeResyCoreSlice = initObserveStore(store, ({ resyCore }) => (resyCore));
  const unsubscribeResyCoreSlice = observeResyCoreSlice(onResyCoreSliceChange);

  const onUserSliceChange = () => {
    // Angular 'UserAuth' and 'UserLogout' event handling
    vm.isAuthenticated = selectIsAuthenticated(getState());
    defer(() => $scope.$apply());
  };

  const observeUserSlice = initObserveStore(store, ({ user }) => (user));
  const unsubscribeUserSlice = observeUserSlice(onUserSliceChange);

  function setupReactors() {
    $scope.$on('$destroy', () => {
      unsubscribeFavoriteSlice();
      unsubscribeCollectionsSlice();
      unsubscribeExperimentsSlice();
      unsubscribeResyCoreSlice();
      unsubscribeResyLocationsSlice();
      unsubscribeUserSlice();
    });

    $rootScope.$on('BLOG_CONTENT_CHANGE', (e, blogContent, blogLinks) => {
      vm.blogContent = blogContent;
      vm.navBlogLinks = blogLinks;
    });
  }

  async function loadEventsByLocation() {
    if (vm.locationCode) {
      try {
        const eventList = await ResyEvents.eventsByLocation({
          locationId: vm.locationCode, limit: 13, startDate: vm.selectedDate, filter_exclusive: null,
        });
        vm.eventsByLocation = eventList;
      } catch (err) {
        Logger.error('[ResyHome] error fetching events by location:', err);
      }
    }
  }

  function loadLocationAndCollections() {
    const location = dispatch(getResyLocationsSelectedThunk());

    if (location) {
      vm.locationCode = location.code;
      vm.locationSlug = location.url_slug;
      vm.locationTier = location.content_tier;
      vm.selectedLocation = location;
      vm.showAllCitiesHeader = !!location.all_cities_header;
      dispatch(fetchLeaderboards({
        locationSlug: vm.locationSlug,
        limit: 5,
      }));
      loadLatLng();
    }
  }

  function loadLatLng() {
    dispatch(getLatLng()).then((latLng) => {
      vm.latLng = latLng;
      defer(() => $scope.$apply());
    });
  }

  function loadDate() {
    vm.selectedDate = dispatch(getSelectedCoreISODateThunk());

    $translate('recommendations')
      .then((translation) => {
        vm.recommendations.name = translation;
      });

    $translate(['book_tonight', 'book_tomorrow', 'book_for'])
      .then((translations) => {
        const language = $translate.proposedLanguage() || $translate.use();
        let collectionFormat;

        vm.bookTonight.formats.sm.sameDay = `[${translations.book_tonight}]`;
        vm.bookTonight.formats.md.sameDay = `[${translations.book_tonight}]`;

        vm.bookTonight.formats.sm.nextDay = `[${translations.book_tomorrow}]`;
        vm.bookTonight.formats.md.nextDay = `[${translations.book_tomorrow}]`;

        if (language) {
          if (language.includes('en')) {
            collectionFormat = !$rootScope.matchMedia.md ? 'MMM. Do' : 'MMMM Do';
          } else if (language.includes('fr') || language.includes('es') || language.includes('ca')) {
            collectionFormat = 'D MMM';
          } else { // Fallback to en
            collectionFormat = !$rootScope.matchMedia.md ? 'MMM. Do' : 'MMMM Do';
          }
        }

        // Language specific
        vm.bookTonight.formats.sm.nextWeek = `[${translations.book_for}] ${collectionFormat}`;
        vm.bookTonight.formats.sm.sameElse = `[${translations.book_for}] ${collectionFormat}`;

        vm.bookTonight.formats.md.nextWeek = `[${translations.book_for}] ${collectionFormat}`;
        vm.bookTonight.formats.md.sameElse = `[${translations.book_for}] ${collectionFormat}`;

        const formats = !$rootScope.matchMedia.md ? vm.bookTonight.formats.sm : vm.bookTonight.formats.md;
        vm.bookTonight.name = moment(vm.selectedDate).calendar(null, formats);
      });
  }

  function loadTime() {
    vm.selectedTime = dispatch(getSelectedCoreTimeThunk());
  }

  function loadPartySize() {
    vm.selectedPartySize = dispatch(getSelectedCoreSeatsThunk());
  }

  function loadNotifyModal({
    activeNotifications,
    selectedDate,
    selectedQuantity,
    notifyService,
    venueId,
    venueName,
    venueUrl,
  }) {
    // needed to normalize the start and end values for the notify modal
    const normalizedActiveNotifications = {};
    Object.keys(activeNotifications).forEach((item) => {
      const {
        time_preferred_end, // eslint-disable-line camelcase
        time_preferred_start, // eslint-disable-line camelcase
        ...args
      } = activeNotifications[item];

      normalizedActiveNotifications[item] = {
        ...args,
        end: time_preferred_end,
        start: time_preferred_start,
      };
    });

    $rootScope.$broadcast('MODAL', 'notify', {
      activeNotifications: normalizedActiveNotifications,
      locationSlug: vm.locationSlug,
      selectedDate,
      selectedQuantity,
      notifyService,
      venueId,
      venueName,
      venueUrl,
    });
  }

  function loadFavorites() {
    if (vm.isAuthenticated) {
      $rootScope.reduxStore.dispatch(getFavoriteVenues());
    } else {
      $rootScope.reduxStore.dispatch(resetFavorites());
    }
  }

  function shouldShowAuth() {
    if ($rootScope.nav.backPath) {
      $rootScope.$broadcast('MODAL', 'signin');
    }
  }

  function selectShouldShowAmexAds(state) {
    return shouldDisplayAd(
      state?.experiments,
      'home_page',
      state?.ipdata?.countryCode
    );
  }
}

export default () => {};
